module.exports = __webpack_public_path__ + "img/youshi2.892cc16a.jpg";